import React from 'react';

export default function IconAlert() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M13 22.75a8.856 8.856 0 1 0 0-17.712 8.856 8.856 0 0 0 0 17.712ZM2.356 6.793l3.56-3.543M23.643 6.793 20.084 3.25"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13 9.75v4.875l1.625 1.625"
      />
    </svg>
  );
}
